import { convertStringDateToDateWithFormat } from "helpers/DateUtils";
import IDisposalSite from "interfaces/IDisposalSite";
import IDisposalSiteViewModel from "interfaces/IDisposalSiteViewModel";
import INonWorkingPeriod from "interfaces/INonWorkingPeriod";
import IRegion from "interfaces/IRegion";

function getRegionsDisplayValue(regions: IRegion[] | null): string {
  let regionsDisplayValue = "";

  if (regions) {
    regionsDisplayValue = regions.map(x => x.name).join(", ");
  }

  return regionsDisplayValue;
}

function getRegionIds(regions: IRegion[] | null): string[] {
  let regionIds: string[] = [];

  if (regions) {
    regionIds = regions.map(x => x.id);
  }

  return regionIds;
}

function getNextNonWorkingDayDisplayValue(
  nextNwd: INonWorkingPeriod | null
): string {
  let nwdDisplayValue = "";

  if (nextNwd) {
    const formattedDate = convertStringDateToDateWithFormat(nextNwd.dateFrom);
    nwdDisplayValue = `${formattedDate} ${nextNwd.name}`;
  }

  return nwdDisplayValue;
}

function getStatusDisplayValue(status: boolean): string {
  return status ? "Active" : "Inactive";
}

function mapDisposalSiteModelToViewModel(
  disposalSite: IDisposalSite
): IDisposalSiteViewModel {
  const disposalSiteViewModel: IDisposalSiteViewModel = {
    regionsDisplayValue: getRegionsDisplayValue(disposalSite.regions),
    nextNonWorkingPeriodDisplayValue: getNextNonWorkingDayDisplayValue(
      disposalSite.nextNonWorkingPeriod
    ),
    statusDisplayValue: getStatusDisplayValue(disposalSite.active),
    id: disposalSite.id,
    name: disposalSite.name,
    active: disposalSite.active,
    latitude: disposalSite.latitude,
    longitude: disposalSite.longitude,
    regions: disposalSite.regions,
    nextNonWorkingPeriod: disposalSite.nextNonWorkingPeriod,
    nonWorkingPeriodIds: disposalSite.nonWorkingPeriodIds
  };

  return disposalSiteViewModel;
}

function mapDisposalSiteModelToViewModels(
  disposalSites: IDisposalSite[] | null
): IDisposalSiteViewModel[] {
  const disposalSiteViewModels: IDisposalSiteViewModel[] = [];

  if (disposalSites) {
    disposalSites.forEach((disposalSite): void => {
      disposalSiteViewModels.push(
        mapDisposalSiteModelToViewModel(disposalSite)
      );
    });
  }

  return disposalSiteViewModels;
}

export {
  mapDisposalSiteModelToViewModel,
  mapDisposalSiteModelToViewModels,
  getRegionIds
};
